export default __webpack_public_path__ + "assets/500d48cae4f2bae7ea3967150fadd4c1.jpg";